import React from 'react';
import { StarIcon, CheckCircleIcon } from 'lucide-react';
interface Review {
  id: string;
  rating: number;
  title: string;
  content: string;
  customerName: string;
  verifiedPurchase: boolean;
  purchaseDate: string;
  daysAgo: number;
  productVariant: {
    name: string;
    storage: string;
    color: string;
    condition: string;
    image: string;
  };
}
export const CustomerReviews = () => {
  const overallRating = 4.8;
  const totalReviews = 80;
  const ratingBreakdown = [{
    stars: 5,
    percentage: 84
  }, {
    stars: 4,
    percentage: 15
  }, {
    stars: 3,
    percentage: 0
  }, {
    stars: 2,
    percentage: 1
  }, {
    stars: 1,
    percentage: 0
  }];
  const reviews: Review[] = [{
    id: '1',
    rating: 4,
    title: 'Téléphone de qualité',
    content: 'Téléphone de qualité, service rapide et service client réactif',
    customerName: 'Rapin',
    verifiedPurchase: true,
    purchaseDate: 'Apr 27, 2025',
    daysAgo: 3,
    productVariant: {
      name: 'Galaxy S24 - Unlocked',
      storage: '128gb',
      color: 'Onyx Black',
      condition: 'Excellent',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9CLQER3mW4v2Jv4RPGHc1W/image.png'
    }
  }, {
    id: '2',
    rating: 5,
    title: 'Product arrived quickly and was exactly...',
    content: 'Product arrived quickly and was exactly as described.',
    customerName: 'Angela G.',
    verifiedPurchase: true,
    purchaseDate: 'May 13, 2025',
    daysAgo: 5,
    productVariant: {
      name: 'Galaxy S24',
      storage: '256gb',
      color: 'Cobalt Violet',
      condition: 'Good',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9CLQER3mW4v2Jv4RPGHc1W/image.png'
    }
  }, {
    id: '3',
    rating: 5,
    title: '2nd-hand shopping without the hassle',
    content: 'The website meant it was like shopping for a new product -- all the details, options and bling -- but it was used! Incredible! Can not recommend highly enough. This is 2nd hand shopping without the speed-bumps & hassle of negotiating with strangers.',
    customerName: 'Richard',
    verifiedPurchase: true,
    purchaseDate: 'May 12, 2025',
    daysAgo: 7,
    productVariant: {
      name: 'Galaxy S24',
      storage: '256gb',
      color: 'Onyx Black',
      condition: 'Excellent',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9CLQER3mW4v2Jv4RPGHc1W/image.png'
    }
  }];
  const renderStars = (rating: number) => {
    return <div className="flex" data-id="element-967">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-5 w-5 ${i < Math.floor(rating) ? 'text-green-500' : 'text-gray-300'}`} fill={i < Math.floor(rating) ? 'currentColor' : 'none'} data-id="element-968" />)}
      </div>;
  };
  return <section className="py-10 border-t border-gray-200" data-id="element-969">
      <div className="container mx-auto px-4" data-id="element-970">
        <h2 className="text-2xl font-bold text-gray-800 mb-8" data-id="element-971">
          Customer Reviews & Ratings
        </h2>
        <div className="flex flex-col lg:flex-row gap-10" data-id="element-972">
          {/* Rating Summary */}
          <div className="w-full lg:w-1/3" data-id="element-973">
            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-974">
              <div className="flex items-center mb-6" data-id="element-975">
                <div className="text-5xl font-bold text-gray-900 mr-4" data-id="element-976">
                  {overallRating}
                </div>
                <div data-id="element-977">
                  <div className="flex mb-1" data-id="element-978">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-5 w-5 ${i < Math.floor(overallRating) ? 'text-green-500' : 'text-gray-300'}`} fill={i < Math.floor(overallRating) ? 'currentColor' : 'none'} data-id="element-979" />)}
                  </div>
                  <div className="text-sm text-gray-600" data-id="element-980">
                    {totalReviews} customer reviews
                  </div>
                </div>
              </div>
              <div className="space-y-2" data-id="element-981">
                {ratingBreakdown.map(item => <div key={item.stars} className="flex items-center" data-id="element-982">
                    <div className="w-16 text-sm text-gray-600" data-id="element-983">
                      {item.stars} star
                    </div>
                    <div className="flex-1 mx-2" data-id="element-984">
                      <div className="h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-985">
                        <div className="h-full bg-green-500 rounded-full" style={{
                      width: `${item.percentage}%`
                    }} data-id="element-986"></div>
                      </div>
                    </div>
                    <div className="w-10 text-sm text-gray-600 text-right" data-id="element-987">
                      {item.percentage}%
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
          {/* Reviews List */}
          <div className="w-full lg:w-2/3" data-id="element-988">
            <div className="space-y-6" data-id="element-989">
              {reviews.map(review => <div key={review.id} className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-990">
                  <div className="flex items-center mb-1" data-id="element-991">
                    {renderStars(review.rating)}
                    <span className="ml-auto text-gray-500 text-sm" data-id="element-992">
                      {review.daysAgo} days ago
                    </span>
                  </div>
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-993">
                    {review.title}
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-994">{review.content}</p>
                  <div className="flex items-center mb-4" data-id="element-995">
                    <span className="font-medium text-gray-800 mr-2" data-id="element-996">
                      {review.customerName}
                    </span>
                    {review.verifiedPurchase && <div className="flex items-center text-sm text-green-700" data-id="element-997">
                        <CheckCircleIcon className="h-4 w-4 mr-1" data-id="element-998" />
                        <span data-id="element-999">Purchased on {review.purchaseDate}</span>
                      </div>}
                  </div>
                  <div className="flex items-center bg-gray-50 p-3 rounded-lg" data-id="element-1000">
                    <img src={review.productVariant.image} alt={review.productVariant.name} className="w-12 h-12 object-contain mr-4" data-id="element-1001" />
                    <div data-id="element-1002">
                      <div className="font-medium text-gray-800" data-id="element-1003">
                        {review.productVariant.name}
                      </div>
                      <div className="text-sm text-gray-600" data-id="element-1004">
                        {review.productVariant.storage} |{' '}
                        {review.productVariant.color} |{' '}
                        {review.productVariant.condition}
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="mt-6 text-center" data-id="element-1005">
              <button className="text-blue-600 font-medium hover:underline" data-id="element-1006">
                See more reviews
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};